const general = {
  specialOffers: 'Специальные предложения',
  restaurantLabel: 'Завтрак',
  readMore: 'Прочитайте больше',
  rooms: 'Апартаменты',
  contactForm: {
    placeholder: 'Адрес Электронной Почты',
    sendAction: 'Отправить',
    sentLabel: 'Спасибо',
    explanation: 'Желаете получать от нас новости и специальные предложения?',
  },
  info: {
    tel: '+382 67 051 736',
    address: 'Cara Dušana 2 85310 Budva Montenegro',
    mail: 'office@lavillabudva.com',
  },
  booking: {
    arrival: 'Датум Доласка',
    nights: 'Ночей',
    check: 'Запас',
    cancel: 'Изменить бронирование',
    code: 'Код доступа',
    optional: 'Необязательно',
  },
};

export default general;